export default __webpack_public_path__ + "static/media/trashCan.34edca3a.svg";